import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/jumprope-partner/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/jumprope-partner',
  name: 'activity_jumprope_partner',
  component: Index,
  props: true,
  meta: {
    title: '跳绳伙伴',
  },
}

export default [indexRoute]
